import PpSideEffects from './PpSideEffects';

export default PpSideEffects;
